module.exports = __webpack_public_path__ + "static/media/vacation4.7dcf3bb9.png";